import loadable from '@loadable/component'
import React from 'react'

import { sendFbClick } from '../../critical/utils/track'
import DealCard from '~/components/deal-card'
import { EcommerceProvider, useEcommerceContext } from '~/contexts/ecommerce-context'
import { usePageContext } from '~/contexts/page-context'
import { useClickoutUrl } from '~/hooks/useClickoutUrl'

import styles from './styles.module.css'

const EcommerceTracking = loadable(() => import('~/components/tracking/ecommerce'))

const Deal = ({ deal, ecommerce, position, isSponsored }) => {
  const {
    data: { list }
  } = useEcommerceContext()

  const handleOnClick = () => {
    ecommerce?.trackClick?.()
    sendFbClick()
  }

  const clickoutLinkUrl = useClickoutUrl({ deal, position })

  return (
    <div className={styles.deal} data-action='click->tracking#sendFbClick'>
      <DealCard
        deal={deal}
        list={list}
        position={position}
        href={clickoutLinkUrl}
        onClick={handleOnClick}
        isSponsored={isSponsored}
        asMobileCard
        isTvHomepage
        criticalJs
      />
    </div>
  )
}

const PromoSlot = ({ dealsFeed }) => {
  const { listnames } = usePageContext()

  if (!dealsFeed) {
    return null
  }

  const list = listnames().table

  const { deals, numberOfSponsoredDeals = 0, comparisonId } = dealsFeed

  const mappedDeals = deals.map((deal, idx) => ({ ...deal, isSponsored: idx < numberOfSponsoredDeals }))

  return (
    <div id='table' className={styles.promoSlot}>
      <EcommerceProvider value={{ comparisonId, deals: mappedDeals, list }}>
        <EcommerceTracking comparisonId={comparisonId} comparison={deals} list={list}>
          {deals.map((deal, idx) => (
            <Deal key={`${deal.id}${idx}`} deal={deal} position={idx + 1} isSponsored={deal.isSponsored} />
          ))}
        </EcommerceTracking>
      </EcommerceProvider>
    </div>
  )
}

export default PromoSlot
